/* ***** ----------------------------------------------- ***** **
** ***** Player JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, TweenMax, Power1, Power2, soundManager */
(function($){
	'use strict';

	Main.modules.audioPlayer = function() {

		var $body = $('body'),
			$content = $('.l-content'),
			$headerAudioPlayer = $('.c-header_audio_player'),
			$headerAudioPlayerButtonSoundCloud = $('.c-header_audio_player_controls-button--soundcloud'),
			$headerAudioPlayerPlaylist = $('.c-header_audio_player_playlist'),
			$headerAudioPlayerPreviousNext = $('.js-player_previous, .js-player_next'),
			$headerAudioPlayerReadyButtons = $('.c-header_audio_player_controls-button--unmute, .c-header_audio_player_controls-button--mute, .c-header_audio_player_controls-button--play, .c-header_audio_player_controls-button--soundcloud'),
			$headerAudioPlayerSeekbar = $('.c-header_audio_player_seekbar'),
			$headerAudioPlayerSeekbarContainer = $('.c-header_audio_player_seekbar-container'),
			$headerAudioPlayerSeekbarLoad = $('.c-header_audio_player_seekbar-bar--load'),
			$headerAudioPlayerSeekbarProgress = $('.c-header_audio_player_seekbar-bar--progress'),
			$headerAudioPlayerToggle = $('.js-header_player_toggle'),
			$headerAudioPlayerTrackTitle = $('.c-header_audio_player_track_info'),
			$headerAudioPlayerVolume = $('.c-header_audio_player_volume'),
			$headerAudioPlayerVolumeBarContainer = $('.c-header_audio_player_volume-bar_container'),
			$headerAudioPlayerVolumeBarHandle = $('.c-header_audio_player_volume-bar_handle'),
			$headerAudioPlayerVolumeBarProgress = $('.c-header_audio_player_volume-bar--progress'),
			$headerAudioPlayerVolumeToggle = $('.js-header_player_volume_toggle'),
			$headerMainIconWaves = $('.c-header_main-header_icon--waves'),
			$postAudioPlayer = $('.o-post_audio_player'),
			$postAudioPlayerIsLoaded = $('.o-post_audio_player--is_loaded'),
			consumerKey = '9337affb1cb1587cad229243d467c2a2',
			errorMessage = 'Error Loading Track.',
			delay = 0.1,
			duration = 0.3,
			headerAudioPlayerSoundCloudURL = $headerAudioPlayer.data('soundcloud_url'),
			headerAudioPlayerResolveURL = 'http://api.soundcloud.com/resolve?url=' + headerAudioPlayerSoundCloudURL + '&format=json&consumer_key=' + consumerKey + '&callback=?',
			utilities = Main.modules.utilities(),
			isMobileWidth = utilities.isMobileWidth(),
			isMediumWidth = utilities.isMediumWidth(),
			playlistObject,
			playlistSize,
			playlistTracks,
			postAudioPlayerArtworkURL,
			postAudioPlayerData,
			postAudioPlayerSoundCloudURL,
			postAudioPlayerResolveURL,

			soundManagerSetUp = function() {

				// Set SoundManager2 variables
				soundManager.url = './../swfs/';
				soundManager.flashVersion = 9;
				soundManager.useFlashBlock = false;
				soundManager.useHighPerformance = true;
				soundManager.wmode = 'transparent';
				soundManager.useFastPolling = true;
				soundManager.debugMode = true;

			},

			soundManagerOnReady = function() {

				soundManager.onready(function() {
					
					// Get JSON data from URL
					$.getJSON(headerAudioPlayerResolveURL, function(data){

						playlistObject = setUpPlaylistData(data);
						playlistTracks = playlistObject.tracks;

						// Enable relevant player controls
						initialTrackSetUp(playlistObject);
						
						loadPlaylist(playlistTracks);

						$headerAudioPlayerReadyButtons.removeClass('c-header_audio_player_controls-button--is_disabled');

					}).fail(function() {
						$headerAudioPlayerTrackTitle.text(errorMessage);
						$headerAudioPlayerTrackTitle.attr('title', errorMessage);
					});

				});

			},

			setUpPlaylistData = function(data) {

				// Set up playlist data based on type: track or playlist
				var dataType = data.kind,
					playlist = [];

				if(dataType == "track") {
					// Load track data into 'tracks' array to match playlist array structure
					playlist['tracks'] = [];
					playlist['tracks'][0] = data;
				} else {
					playlist = data;
				}

				return playlist;

			},

			initialTrackSetUp = function(data) {

				var firstTrackTitle = data.tracks[0].title;

				// Populate player with the (first) track's title and permalink
				$headerAudioPlayerTrackTitle.text(firstTrackTitle);
				$headerAudioPlayerTrackTitle.attr('title', firstTrackTitle);
				$headerAudioPlayerButtonSoundCloud.attr('href', headerAudioPlayerSoundCloudURL);

			},

			loadPlaylist = function(playlist, isPostAudioPlayer) {

				// Loop through each of the tracks
				$.each(playlist, function(index, track){

					var trackID = track.id,
						trackTitle = track.title,
						$trackElement = $('<li>' + trackTitle + '</li>'),
						trackSoundCloudURL = track.permalink_url,
						trackStreamURL = track.stream_url,
						trackIDWithPrefix = 'track_' + trackID,
						streamURL = updateStreamURL(trackStreamURL);

					// Create a list item for each track and associate the track data with it.
					$trackElement.data('track_id', trackIDWithPrefix).appendTo('.c-header_audio_player_playlist');

					// Create the sound using SoundManager2
					soundManager.createSound({
						
						// Give the sound an id and the SoundCloud stream url we created above.
						id: trackIDWithPrefix,
						url: streamURL,

						onplay: function() {

							$headerAudioPlayer.addClass('c-header_audio_player--is_playing');

							// When track is playing/loaded, allow user to jump position in track by clicking seekbar
							if(!$headerAudioPlayer.hasClass('c-header_audio_player--seekbar_is_active')){
								$headerAudioPlayer.addClass('c-header_audio_player--seekbar_is_active');
							}

							// Set UI
							$headerAudioPlayerTrackTitle.text(trackTitle);
							$headerAudioPlayerTrackTitle.attr('title', trackTitle);
							$headerAudioPlayerButtonSoundCloud.attr('href', trackSoundCloudURL);
							$headerAudioPlayerSeekbarLoad.css('width', '0%');
							$headerAudioPlayerSeekbarProgress.css('width', '0%');

							// If there are more than one track in the playlist, enable previous and next buttons
							// If not, disable
							// Use selector in this scope to get most current list of tracks
							playlistSize = $('.c-header_audio_player_playlist li').length;

							if (playlistSize > 1) {
								$headerAudioPlayerPreviousNext.removeClass('c-header_audio_player_controls-button--is_disabled');
							} else {
								$headerAudioPlayerPreviousNext.addClass('c-header_audio_player_controls-button--is_disabled');
							}

						},

						onresume: function() {
							$headerAudioPlayer.addClass('c-header_audio_player--is_playing');

							if (isPostAudioPlayer) {
								$('.o-post_audio_player--is_loaded').addClass('o-post_audio_player--is_playing');
							}
						},

						onpause: function() {
							$headerAudioPlayer.removeClass('c-header_audio_player--is_playing');

							if (isPostAudioPlayer) {
								$('.o-post_audio_player--is_loaded').removeClass('o-post_audio_player--is_playing');
							}
						},

						whileloading: function() {
							$headerAudioPlayerSeekbarLoad.css('width', ( this.bytesLoaded / this.bytesTotal ) * 100 + '%');
						},

						whileplaying: function() {
							$headerAudioPlayerSeekbarProgress.css('width', ( this.position / this.duration ) * 100 + '%');
						},

						onfinish: function() {
							$headerAudioPlayer.removeClass('c-header_audio_player--is_playing');

							if (isPostAudioPlayer) {
								$postAudioPlayerIsLoaded.removeClass('o-post_audio_player--is_playing');
							}

							nextTrack();
						}

					});

				});

			},

			updateStreamURL = function(url) {

				// Get appropriate stream url depending on whether the playlist is private or public.
				// If the track includes a *secret_token* add a '&' to the url, else add a '?'.
				// Finally, append the consumer key and you'll have a working stream url.
				if (url.indexOf("secret_token") == -1) {
					url = url + '?';
				} else {
					url = url + '&';
				}
				
				url = url + 'consumer_key=' + consumerKey;

				return url;

			},

			headerAudioPlayerToggle = function() {

				// Show/hide header player toggle on mobile/tablet
				$headerAudioPlayerToggle.on('click', function() {

					var $this = $(this);

					if (!$headerAudioPlayer.hasClass('c-header_audio_player--is_active')) {

						TweenMax.to($headerAudioPlayer, duration, {
							y: '45',
							ease: Power2.easeInOut
						});

						TweenMax.to($headerAudioPlayerSeekbar, duration, {
							y: '40',
							ease: Power2.easeInOut,
							delay: delay
						});

					} else {

						TweenMax.to($headerAudioPlayer, duration, {
							y: '0',
							ease: Power2.easeInOut
						});

						TweenMax.to($headerAudioPlayerSeekbar, duration, {
							y: '0',
							ease: Power2.easeInOut
						});

					}

					$headerAudioPlayer.toggleClass('c-header_audio_player--is_active');
					$this.toggleClass('c-header_main-header_icon--waves--is_active');

				});

			},

			headerAudioPlayerVolumeToggle = function() {

				$headerAudioPlayerVolumeToggle.on('click', function() {

					if (!$headerAudioPlayerVolume.hasClass('c-header_audio_player_volume--is_active')){

						$headerAudioPlayerVolume.addClass('c-header_audio_player_volume--is_active');

						TweenMax.to($headerAudioPlayerVolume, 0.2, {
							opacity: 1,
							ease: Power1.easeInOut,
							width: '100%'
						});

					} else {

						TweenMax.to($headerAudioPlayerVolume, 0.2, {
							opacity: 0,
							ease: Power1.easeInOut,
							width: '30%'
						});

						setTimeout(function() {
							$headerAudioPlayerVolume.removeClass('c-header_audio_player_volume--is_active');
						}, 200);

					}
					
				});

			},

			nextTrack = function() {

				var $trackCurrent = $('.c-header_audio_player_playlist li.current'),
					$trackFirst = $('.c-header_audio_player_playlist li:first');

				// Stop all sounds
				soundManager.stopAll();
				
				// Click the next track after the current one
				// If it does not exist (there is no next track), click the first track
				if ($trackCurrent.next().click().length == 0) {
					$trackFirst.click();
				}

			},

			prevTrack = function() {

				var $trackCurrent = $('.c-header_audio_player_playlist li.current'),
					$trackLast = $('.c-header_audio_player_playlist li:last-child');

				// Stop all sounds
				soundManager.stopAll();
				
				// Click the prev track after the current one
				// If it does not exist (there is no prev track), click the last track
				if ($trackCurrent.prev().click().length == 0) {
					$trackLast.click();
				}

			},

			trackOnClick = function() {

				// Bind a click event to each list item we created above.
				$headerAudioPlayer.on('click', '.c-header_audio_player_playlist li', function() {
					
					// Create a track variable, grab the data from it, and find out if it's already playing
					var $track = $(this),
						trackID = $track.data('track_id'),
						current = $track.is('.current');
							
					if (current) {
						// If currently loaded track is clicked, play/pause
						soundManager.togglePause(trackID);				
					} else {

						// If it's not playing, stop all other sounds that might be playing and play the clicked sound
						if ($track.siblings('li').hasClass('current')) {
							soundManager.stopAll();
						}
						soundManager.play(trackID);
					
						// Toggle the 'current' state of the clicked li and remove 'current' from and other tracks.
						$track.toggleClass('current').siblings('li').removeClass('current');
					}
					
				});

			},

			playPauseOnClick = function() {

				// Bind a click event to the play / pause button.
				$headerAudioPlayer.on('click', '.js-player_play, .js-player_pause', function() {

					var $track = $('.c-header_audio_player_playlist li'),
						$trackCurrent = $('.c-header_audio_player_playlist li.current'),
						$trackFirst = $('.c-header_audio_player_playlist li:first');

					if ($track.hasClass('current') == true) {

						var activeTrackID = $trackCurrent.data('track_id');
						
						// If a track is active, play or pause it depending on current state.
						soundManager.togglePause(activeTrackID);	
									
					} else {
						// If no tracks are active, just play the first one.
						$trackFirst.click();
					}
					
				});

			},

			nextOnClick = function() {

				// Bind a click event to the next button, calling the Next Track function.
				$headerAudioPlayer.on('click', '.js-player_next', function() {
					nextTrack();
				});

			},

			prevOnClick = function() {

				// Bind a click event to the previous button, calling the Previous Track function.
				$headerAudioPlayer.on('click', '.js-player_previous', function() {
					prevTrack();
				});

			},

			seekbarOnClick = function() {

				// When user clicks onseekbar, go to that location in the track
				$headerAudioPlayer.on('click', '.c-header_audio_player_seekbar-container', function(e){
					trackJumpPosition(this, e);
				});

			},

			volumeBarOnClick = function() {

				// When user clicks volume bar, go to that volume position
				$headerAudioPlayerVolume.on('click', '.c-header_audio_player_volume-bar_container', function(e){
					setVolume(this, e);
				});

			},

			trackSeekbarDraggable = function() {

				// Allows user to drag progress bar on seekbar 
				$headerAudioPlayerSeekbarContainer.draggable({
					containment: "parent",
					scroll: false,
					axis: "x",
					drag: function (e) {
						trackJumpPosition(this, e);
					},
					stop: function (e) {
						trackJumpPosition(this, e);
					}
				});

			},

			volumeBarDraggable = function() {

				// Allows user to drag soundwave on seekbar 
				$headerAudioPlayerVolumeBarContainer.draggable({
					containment: "parent",
					scroll: false,
					axis: "x",
					drag: function (e) {
						setVolume(this, e);
					},
					stop: function (e) {
						setVolume(this, e);
					}
				});

			},

			trackJumpPosition = function(object, e) {

				var objectWidth = $(object).outerWidth(),
					currentPosition = e.pageX - $(object).offset().left,
					percentPosition = currentPosition / objectWidth,
					activeTrackID = $('.c-header_audio_player_playlist li.current').data('track_id'),
					trackDuration = soundManager.getSoundById( activeTrackID ).duration,
					newPosition = percentPosition * trackDuration;

				// Jump to position on seekbar based on click
				if (soundManager.getSoundById( activeTrackID ).playState == 1) {
					soundManager.setPosition( activeTrackID, newPosition );
				}

			},

			setVolume = function(object, e) {

				var objectWidth = $(object).outerWidth(),
					currentPosition = e.pageX - $(object).offset().left,
					percentPosition = currentPosition / objectWidth * 100,
					precentPositionCSS;

				// Do not allow the percentage to go below 0 or above 100
				if (percentPosition >= 100) {
					precentPositionCSS = '100%';
				} else if (percentPosition <= 0) {
					precentPositionCSS = '0';
				} else {
					precentPositionCSS = percentPosition + '%';
				}

				// When volume is at 0, display mute icon
				if (percentPosition <= 0) {
					$headerAudioPlayer.addClass('c-header_audio_player--is_muted');
				} else {
					if ($headerAudioPlayer.hasClass('c-header_audio_player--is_muted')) {
						$headerAudioPlayer.removeClass('c-header_audio_player--is_muted');
					}
				}

				soundManager.setVolume(percentPosition);
				$headerAudioPlayerVolumeBarHandle.css('left', precentPositionCSS);
				$headerAudioPlayerVolumeBarProgress.css('width', precentPositionCSS);

			},

			postAudioPlayerPreload = function() {

				$postAudioPlayer.each(function() {

					var $this = $(this);

					postAudioPlayerSoundCloudURL = $this.data('soundcloud_url'),
					postAudioPlayerResolveURL = 'http://api.soundcloud.com/resolve?url=' + postAudioPlayerSoundCloudURL + '&format=json&consumer_key=' + consumerKey + '&callback=?';

					// Get JSON data from URL
					$.getJSON(postAudioPlayerResolveURL, function(data){

						// Store data from URL into data element for when the user clicks play
						$this.data('audio_data', data);

						// Check if track/playlist contains artwork. If so, set image in player
						postAudioPlayerArtworkURL = data.artwork_url;

						if (postAudioPlayerArtworkURL) {
							$this.find('.o-post_audio_player-image').css('background-image', 'url(" ' + postAudioPlayerArtworkURL + '")');
						}

						// Remove loading animationa and display player
						$this.addClass('o-post_audio_player--is_ready');

					}).fail(function() {

						// Remove loading animation and display error message on failure
						$this.append('<div class="o-post_audio_player-error">Error Loading Track.</div>');
						$this.addClass('o-post_audio_player--is_ready');

					});

				});

			},

			postAudioPlayerPlayPauseOnClick = function() {

				$content.on('click', '.js-play_audio_toggle', function() {

					var $this = $(this),
						$thisPostAudioPlayer = $this.closest('.o-post_audio_player'),
						postAudioPlayerSoundCloudURL = $thisPostAudioPlayer.data('soundcloud_url'),
						activeTrackID;

					if ($thisPostAudioPlayer.hasClass('o-post_audio_player--is_loaded')) {

						// If the track/playlist from this post audio player is loaded, play/pause the current track
						activeTrackID = $('.c-header_audio_player_playlist li.current').data('track_id');
						soundManager.togglePause(activeTrackID);

					} else {

						// If a track is currently playing, stop it
						if ($headerAudioPlayer.hasClass('c-header_audio_player--is_playing')) {
							soundManager.stopAll();
						}

						// Get data from this post audio player and set up variables
						postAudioPlayerData = $this.closest('.o-post_audio_player').data('audio_data');

						playlistObject = setUpPlaylistData(postAudioPlayerData);
						playlistTracks = playlistObject.tracks;

						// Destroy all tracks currently loaded
						// Use selector in this scope to get most current list of tracks
						$('.c-header_audio_player_playlist li').each(function() {
							activeTrackID = $(this).data('track_id');
							soundManager.destroySound(activeTrackID);
						});

						$headerAudioPlayerPlaylist.empty();
						
						// Load track/playlist into header audio player
						loadPlaylist(playlistTracks, true);

						// Set the SoundCloud URL of the header audio player to the URL of this post audio player
						// Serves as a reference point to allow syncing between the header audio player and post audio player when browsing
						$headerAudioPlayer.data('soundcloud_url', postAudioPlayerSoundCloudURL);

						// Clear the status on all post audio players and add classes for loaded and playing
						$thisPostAudioPlayer.addClass('o-post_audio_player--is_loaded')
							.siblings('.o-post_audio_player').removeClass('o-post_audio_player--is_loaded');
						$thisPostAudioPlayer.addClass('o-post_audio_player--is_playing')
							.siblings('.o-post_audio_player').removeClass('o-post_audio_player--is_playing');

						// If viewport is medium width (960px) or under, 
						// flash waves icon in header to show that a track has been loaded into the header audio player
						if (isMobileWidth || isMediumWidth) {
							$headerMainIconWaves.addClass('c-header_main-header_icon--waves--is_highlighted');
							setTimeout(function() {
								$headerMainIconWaves.removeClass('c-header_main-header_icon--waves--is_highlighted');
							}, 500);
						}

						// Add current status to first track and play
						// Use selector in this scope to get the first track of the current list
						$('.c-header_audio_player_playlist li:first-child').addClass('current');
						activeTrackID = $('.c-header_audio_player_playlist li:first-child').data('track_id');
						soundManager.play(activeTrackID);

					}

				});

			},

			checkAndSyncAudioPlayers = function() {

				// Check if the current track/playlist that is loaded/playing in the header music player matches with a post audio player
				// If so, add the proper classes to sync the player controls

				headerAudioPlayerSoundCloudURL = $headerAudioPlayer.data('soundcloud_url');

				$postAudioPlayer.each(function() {

					var $this = $(this);
					postAudioPlayerSoundCloudURL = $(this).data('soundcloud_url');

					if (headerAudioPlayerSoundCloudURL == postAudioPlayerSoundCloudURL) {
						$this.addClass('o-post_audio_player--is_loaded');

						if($headerAudioPlayer.hasClass('c-header_audio_player--is_playing')) {
							$this.addClass('o-post_audio_player--is_playing');
						}
					}

				});

			};

		return {
			init: function() {
				soundManagerSetUp();
				soundManagerOnReady();
				headerAudioPlayerToggle();
				headerAudioPlayerVolumeToggle();
				nextOnClick();
				prevOnClick();
				trackOnClick();
				playPauseOnClick();
				seekbarOnClick();
				volumeBarOnClick();
				trackSeekbarDraggable();
				volumeBarDraggable();
				postAudioPlayerPlayPauseOnClick();

				if ($body.hasClass('single')) {
					postAudioPlayerPreload();
					checkAndSyncAudioPlayers();
				}
			},
			postAudioPlayerPreload: postAudioPlayerPreload,
			checkAndSyncAudioPlayers: checkAndSyncAudioPlayers
		}
		
	};

})(jQuery);